import r from "./underscore.js";
import { toString as t, SymbolProto as e } from "./_setup.js";
import o from "./_getByteLength.js";
import f from "./isTypedArray.js";
import n from "./isFunction.js";
import { hasStringTagBug as i } from "./_stringTagBug.js";
import u from "./isDataView.js";
import c from "./keys.js";
import s from "./_has.js";
import a from "./_toBufferView.js";
var p = "[object DataView]";
function j(j, l) {
  return function j(l, m, b, y) {
    if (l === m) return 0 !== l || 1 / l == 1 / m;
    if (null == l || null == m) return !1;
    if (l != l) return m != m;
    var g = typeof l;
    return ("function" === g || "object" === g || "object" == typeof m) && function l(m, b, y, g) {
      m instanceof r && (m = m._wrapped), b instanceof r && (b = b._wrapped);
      var h = t.call(m);
      if (h !== t.call(b)) return !1;
      if (i && "[object Object]" == h && u(m)) {
        if (!u(b)) return !1;
        h = p;
      }
      switch (h) {
        case "[object RegExp]":
        case "[object String]":
          return "" + m == "" + b;
        case "[object Number]":
          if (+m != +m) return +b != +b;
          return 0 == +m ? 1 / +m == 1 / b : +m == +b;
        case "[object Date]":
        case "[object Boolean]":
          return +m == +b;
        case "[object Symbol]":
          return e.valueOf.call(m) === e.valueOf.call(b);
        case "[object ArrayBuffer]":
        case p:
          return l(a(m), a(b), y, g);
      }
      var v = "[object Array]" === h;
      if (!v && f(m)) {
        if (o(m) !== o(b)) return !1;
        if (m.buffer === b.buffer && m.byteOffset === b.byteOffset) return !0;
        v = !0;
      }
      if (!v) {
        if ("object" != typeof m || "object" != typeof b) return !1;
        var _ = m.constructor,
          w = b.constructor;
        if (_ !== w && !(n(_) && _ instanceof _ && n(w) && w instanceof w) && "constructor" in m && "constructor" in b) return !1;
      }
      g = g || [];
      for (var d = (y = y || []).length; d--;) if (y[d] === m) return g[d] === b;
      if (y.push(m), g.push(b), v) {
        if ((d = m.length) !== b.length) return !1;
        for (; d--;) if (!j(m[d], b[d], y, g)) return !1;
      } else {
        var B,
          O = c(m);
        if (d = O.length, c(b).length !== d) return !1;
        for (; d--;) if (!(s(b, B = O[d]) && j(m[B], b[B], y, g))) return !1;
      }
      return y.pop(), g.pop(), !0;
    }(l, m, b, y);
  }(j, l);
}
export { j as default };